(function() {
  'use strict';

  function validator(Utils) {
    return {
      require: 'ngModel',
      link: function(_scope, _element, _attrs, ngModel) {
        ngModel.$validators.email = function(value) {
          if (_.isEmpty(value)) {
            return true;
          }

          if (_.isObject(value)) {
            return true;
          }

          var res = Utils.validateEmail(value);
          return res;
        };
      }
    };
  }

  validator.$inject = ['UtilsService'];
  angular.module('blocks.utils')
    .directive('inviteValidator', validator);
})();
